import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Info } from "lucide-react";

export function InfoHint({ text, testid = "info-hint" }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          aria-label="info"
          className="text-[#6E6B65] hover:text-[#3F6E85] transition-colors"
        >
          <Info className="w-[18px] h-[18px]" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="max-w-xs text-sm text-[#3a3a3a] leading-relaxed rounded-xl border-stone-200">
        {text}
      </PopoverContent>
    </Popover>
  );
}
